export default "__VITE_PUBLIC_ASSET__4bdbe563__"